import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { CierresMensualesProduccionApi } from "../../../api/CierresMensualesProduccionApi";

// Lo que quedó registrado en un cierre y su comparativo. El cierre se pide
// primero: sin él la pantalla no tiene ni encabezado ni alcance que mostrar
export const useDetalleCierreMensualProduccion = (cierreId) => {
    const {
        getCierre,
        getComparativoDelCierre,
        descargarComparativoDelCierreExcel,
        cargando,
    } = CierresMensualesProduccionApi();

    const [cierre, setCierre] = useState(null);
    const [comparativo, setComparativo] = useState(null);

    // el error se muestra en lugar de las tablas, porque sin comparativo la
    // pantalla se queda sin qué mostrar
    const [mensajeError, setMensajeError] = useState("");

    const Consultar = async () => {
        setMensajeError("");

        try {
            setCierre(await getCierre(cierreId));
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el cierre",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setMensajeError(errorMsg);
            return;
        }

        try {
            setComparativo(await getComparativoDelCierre(cierreId));
        } catch (error) {
            setMensajeError(
                getErrorFromResponse(
                    error,
                    "Error al obtener el comparativo del cierre",
                ),
            );
        }
    };

    useEffect(() => {
        Consultar();
    }, [cierreId]);

    const DescargarExcel = async () => {
        try {
            await descargarComparativoDelCierreExcel(cierreId);
        } catch (error) {
            NotificationManager.error(
                getErrorFromResponse(
                    error,
                    "Error al exportar el cierre mensual",
                ),
                "Error",
                3000,
            );
        }
    };

    return {
        cierre,
        comparativo,
        mensajeError,

        descargarExcel: DescargarExcel,

        cargando,
    };
};
